export const dates = [
    "today",
    "yesterday",
    "dayBeforeYesterday",
    "currMonth",
    "lastMonth",
    "lastToLastMonth"
];

const categoriesIIMJOBS = [
    {
        title: "Banking & Finance",
        key: "cat13"
    },
    {
        title: "Sales & Marketing",
        key: "cat14"
    },
    {
        title: "Consulting",
        key: "cat16"
    },   
    {
        title: "HR & IR",
        key: "cat17"
    },    
    {
        title: "IT & Systems",
        key: "cat15"
    },
    {
        title: "SCM & Operations",
        key: "cat19"
    },
    {
        title: "BPO",
        key: "cat22"
    },
    {
        title: "Legal",
        key: "cat21"
    },
    {
        title: "Healthcare",
        key: "cat23"
    },
    {
        title: "Pharma",
        key: "cat24"
    },
    {
        title: "GenAI",
        key: "cat25"
    }
];

const categoriesHIRIST = [
  { title: "AI/ML", key: "cat14" },
  { title: "Data Engineering", key: "cat15" },
  { title: "Full Stack", key: "cat16" },
  { title: "CyberSecurity", key: "cat17" },
  { title: "Backend Development", key: "cat1" },
  { title: "UI & Design", key: "cat10" },
  { title: "Quality Assurance", key: "cat11" },
  { title: "Product Management", key: "cat12" },
  { title: "Business Analysis and Project Management", key: "cat13" },
  { title: "Frontend Development", key: "cat2" },
  { title: "Other", key: "cat3" },
  { title: "Semiconductor/VLSI/EDA", key: "cat4" },
  { title: "Mobile Applications", key: "cat5" },
  { title: "Platform Engineering / SAP/Oracle Jobs", key: "cat6" },
  { title: "Data Analytics & BI", key: "cat7" },
  { title: "DevOps / SRE", key: "cat8" },
  { title: "Emerging Technologies & Roles", key: "cat9" }
];

const categoriesUPDAZZ = [
    {
        key: "cat14",
        title: "BFSI Sales"
    },
    {
        key: "cat2",
        title: "B2B/Corporate Sales"
    },
    {
        key: "cat1",
        title: "B2C/Retail/Channel Sales"
    },
    {
        key: "cat11",
        title: "Online/Digital marketing"
    },
    {
        key: "cat5",
        title: "Telesales/Inside Sales/BPO"
    },
    {
        key: "cat15",
        title: "IT Sales"
    },
    {
        key: "cat9",
        title: "Marketing/PR/Advertising"
    },
    {
        key: "cat8",
        title: "After-Sales / Customer Service"
    },
    {
        key: "cat10",
        title: "Content/Design"
    },
    {
        key: "cat7",
        title: "Pre-Sales"
    },
    {
        key: "cat6",
        title: "Sales Management"
    }
]

let selectedCategories;

if(process.env.REACT_APP_PLATFORM == 'hirist') {
    selectedCategories = categoriesHIRIST;
}
else if(process.env.REACT_APP_PLATFORM == 'updazz') {
    selectedCategories = categoriesUPDAZZ
}

else {
    selectedCategories = categoriesIIMJOBS;
}
export const categories = selectedCategories;

export const actions = [
    {
        title: "Unpublished",
        key: "unpub"
    },
    {
        title: "Refreshed",
        key: "ref"
    }
];

export const socials = [
    {
        title: "Shared on LinkedIn (Dashboard)",
        key: "linkedIn"
    },
    {
        title: "Shared on twitter",
        key: "twitter"
    }
]